import React from "react";
import cls from "./notificationStats.module.scss";
import useModal from "hooks/useModal";
import Notification2LineIcon from "remixicon-react/Notification2LineIcon";
import { useQuery } from "react-query";
import notificationService from "services/notification";
import { useAuth } from "contexts/auth/auth.context";
import { useMediaQuery } from "@mui/material";
import dynamic from "next/dynamic";
import Loading from "components/loader/loading";

const DrawerContainer = dynamic(() => import("containers/drawer/drawer"));
const MobileDrawer = dynamic(() => import("containers/drawer/mobileDrawer"));
const NotificationCenter = dynamic(
  () => import("components/notificationCenter/notificationCenter"),
  {
    loading: () => <Loading />,
  },
);

type Props = {};

export default function NotificationStats({}: Props) {
  const isMobile = useMediaQuery("(max-width:640px)");
  const { isAuthenticated } = useAuth();
  const [modal, handleOpen, handleClose] = useModal();

  const { data } = useQuery(
    ["notificationStatistic", isAuthenticated],
    () => notificationService.getStatistics(),
    {
      enabled: isAuthenticated,
      retry: false,
      refetchInterval: 10000,
      refetchOnWindowFocus: isAuthenticated,
      staleTime: 0,
    },
  );

  return (
    <div>
      <button className={cls.wrapper} onClick={handleOpen}>
        <div className={cls.icon}>
          <Notification2LineIcon />
        </div>
        {!!data?.notification && <div className={cls.badge} />}
      </button>
      {!isMobile ? (
        <DrawerContainer
          open={modal}
          onClose={handleClose}
          anchor="right"
          PaperProps={{ style: { minWidth: "550px", padding: 0 } }}
        >
          <NotificationCenter onClose={handleClose} />
        </DrawerContainer>
      ) : (
        <MobileDrawer open={modal} onClose={handleClose}>
          <NotificationCenter onClose={handleClose} />
        </MobileDrawer>
      )}
    </div>
  );
}
